import { Injectable } from '@angular/core';
import {
    ILeadsParameters,
    ILeadsPartners,
    ILeadsSmalCard,
    ILeadsSummary,
} from '../interfaces/stanalone-components.data';
import {
    IBottomCardData,
    IRowItems,
    ITableTdItems,
    SmallCardData,
} from '../../../../shared/interfaces/card-data';
import { NoDataActionType } from '../../../../shared/interfaces/no-data';
import { ReusableFunctions } from '../../../../shared/classes/reusable-functions';
import { DisplayOptions } from '../../../../shared/interfaces/display-options';
import { LeadsPartnersService } from '../../../../leads-partners/services/leads-partners.service';
import { UserAccessService } from '../../../../shared/services/user-access.service';
import { ICardlistData } from '../../../../shared/components/card-list/card-list.component';
import { LargeCardComponent } from '../../../../shared/components/large-card/large-card.component';

@Injectable({
    providedIn: 'root',
})
export class SmallMediumCardService {
    constructor(
        private reusableFunctions: ReusableFunctions,
        private _leadsPartnersService: LeadsPartnersService,
        private _userAccessService: UserAccessService
    ) {}

    initializeSamllCard(leadsPartnersSmallCard: ILeadsSmalCard) {
        let smallCardInitial: SmallCardData = {
            cardId: '',
            title: '',
            mainValue: '',
            comparisonValue: '',
            routerLink: '',
            urlSegment: '',
            faIcon: '',
            faIconColor: '',
            isDataReady: false,
            unit: '',
            bottomCardData: [],
            showCardControllers: true,
        };

        leadsPartnersSmallCard.card = Object.assign({}, smallCardInitial);
        leadsPartnersSmallCard.card.cardId = leadsPartnersSmallCard.cardId;
        leadsPartnersSmallCard.card.title = leadsPartnersSmallCard.title;
        leadsPartnersSmallCard.card.routerLink = '/reporting/leads-partners/';
        leadsPartnersSmallCard.card.urlSegment = leadsPartnersSmallCard.urlSegment;
        return leadsPartnersSmallCard;
    }

    initializeTableCard(leadsPartnersLargeCard: ICardlistData) {
        leadsPartnersLargeCard.hasData = false;
        leadsPartnersLargeCard.isDataReady = false;
        leadsPartnersLargeCard.baseUrl = '/reporting/leads-partners/';
        leadsPartnersLargeCard.routerPath =
            leadsPartnersLargeCard.baseUrl + leadsPartnersLargeCard.cardId;
        leadsPartnersLargeCard.showCardControllers = true;
        return Object.assign({}, leadsPartnersLargeCard);
    }

    getLeadsAndPartnersParameters(displayOptions: DisplayOptions[], hFilterJSON: string) {
        let dateRange =
            displayOptions.find((x) => x.optionKey == 'dateRange_y_q_m')?.selectedOptions ?? '';
        let channel = displayOptions.find((x) => x.optionKey === 'channel')?.selectedOptions ?? '';
        let loanType =
            displayOptions.find((x) => x.optionKey === 'loanCategory')?.selectedOptions ?? '';
        let loanPurpose =
            displayOptions.find((x) => x.optionKey === 'loanPurpose')?.selectedOptions ?? '';
        let priorCompareTo =
            displayOptions.find((x) => x.optionKey == 'compareTo')?.selectedOptions ?? '';

        let parameters: ILeadsParameters = {
            fromDatePeriod: dateRange,
            priorCompareTo: priorCompareTo,
            partnerType: null,
            partnerCode: 'B',
            isReturnAll: '0',
            hFilterJSON: hFilterJSON,
            channel: channel,
            loanPurpose: loanPurpose,
            loanType: loanType,
            type: 'X',
        };
        return parameters;
    }

    prepareLeadsAndPartnersSmallcardData(
        leadsPartnersSmallCard: ILeadsSmalCard,
        displayOptions: DisplayOptions[],
        hFilterJSON: string,
        action: NoDataActionType
    ) {
        let parameters = this.getLeadsAndPartnersParameters(displayOptions, hFilterJSON);
        if (leadsPartnersSmallCard.cardGroup === 'summary') {
            this._leadsPartnersService.getLeadsSummary(parameters).subscribe(
                (res) => {
                    let dataPerType = res.filter(
                        (item) => item.cardDescription === leadsPartnersSmallCard.databaseCardId
                    );
                    this.handleResponse_smallCards(dataPerType, leadsPartnersSmallCard, action);
                },
                () => {
                    this.handleResponse_smallCards(
                        [],
                        leadsPartnersSmallCard,
                        NoDataActionType.error
                    );
                }
            );
        }

        if (leadsPartnersSmallCard.cardGroup === 'pullthrough') {
            this._leadsPartnersService.getLeadsPullThru(parameters).subscribe(
                (res) => {
                    let dataPerType = res.filter(
                        (item) => item.cardDescription === leadsPartnersSmallCard.databaseCardId
                    );
                    this.handleResponse_smallCards(dataPerType, leadsPartnersSmallCard, action);
                },
                () => {
                    this.handleResponse_smallCards(
                        [],
                        leadsPartnersSmallCard,
                        NoDataActionType.error
                    );
                }
            );
        }
    }

    prepareLeadsAndPartnersLargecardData(
        leadsPartnersLargeCard: ICardlistData,
        displayOptions: DisplayOptions[],
        hFilterJSON: string,
        action: NoDataActionType
    ) {
        let parameters = this.getLeadsAndPartnersParameters(displayOptions, hFilterJSON);
        if (leadsPartnersLargeCard.type === 'B') {
            this._leadsPartnersService.getPartnerSourceCard(parameters).subscribe((res) => {
                this.handleResponse_largeCards(res, leadsPartnersLargeCard, action);
            }),
                () => {
                    this.handleResponse_largeCards(
                        [],
                        leadsPartnersLargeCard,
                        NoDataActionType.error
                    );
                };
        } else {
            this._leadsPartnersService.getLeadSourceCard(parameters).subscribe(
                (res) => {
                    this.handleResponse_largeCards(res, leadsPartnersLargeCard, action);
                },
                () => {
                    this.handleResponse_largeCards(
                        [],
                        leadsPartnersLargeCard,
                        NoDataActionType.error
                    );
                }
            );
        }
    }

    handleResponse_largeCards(
        data: ILeadsPartners[],
        cardInfo: ICardlistData,
        action: NoDataActionType
    ) {
        let leadsTableInfo: ITableTdItems[] = [
            {
                headerTitle: '',
                fieldId: 'type',
                headerStyle: {
                    width: '25%',
                    color: '#333333',
                    'font-size': '13px',
                    'text-transform': 'uppercase',
                },
                style: {
                    'font-weight': '500',
                    'font-size': '14px',
                    'text-align': 'left',
                    width: '25%',
                },
                isHyperlinked: true,
                hyperlinkFieldId: 'type',
            },
            {
                headerTitle: 'Leads',
                fieldId: 'count',
                headerStyle: {
                    width: '10%',
                    'text-align': 'right',
                    color: '#333333',
                    'font-size': '13px',
                    'text-transform': 'uppercase',
                },
                style: {
                    'text-align': 'right',
                    'font-size': '14px',
                    width: '10%',
                    'white-space': 'nowrap',
                },
                dataType: 'number',
                precision: 0,
            },
            {
                headerTitle: 'Volume',
                fieldId: 'volume',
                headerStyle: {
                    width: '15%',
                    'text-align': 'right',
                    color: '#333333',
                    'font-size': '13px',
                    'text-transform': 'uppercase',
                },
                style: {
                    'text-align': 'right',
                    'font-size': '14px',
                    width: '15%',
                    'white-space': 'nowrap',
                },
                dataType: 'currency',
                precision: 0,
            },
            {
                headerTitle: 'Avg Credit',
                fieldId: 'avgCredit',
                headerStyle: {
                    width: '10%',
                    'text-align': 'right',
                    color: '#333333',
                    'font-size': '13px',
                    'text-transform': 'uppercase',
                },
                style: {
                    'text-align': 'right',
                    'font-size': '14px',
                    width: '10%',
                    'white-space': 'nowrap',
                },
                dataType: 'number',
                precision: 0,
            },
            {
                headerTitle: 'App Conversion',
                fieldId: 'leadToAppPullThru',
                isHyperlinked: false,
                headerStyle: {
                    width: '20%',
                    'text-align': 'right',
                    color: '#333333',
                    'font-size': '13px',
                    'text-transform': 'uppercase',
                },
                style: {
                    'text-align': 'right',
                    'font-size': '14px',
                    'white-space': 'nowrap',
                },
                dataType: 'percentage',
                precision: 2,
            },
            {
                headerTitle: 'Funded Conversion',
                fieldId: 'leadToFundPullThru',
                isHyperlinked: false,
                headerStyle: {
                    width: '20%',
                    'text-align': 'right',
                    'padding-right': '8px',
                    color: '#333333',
                    'font-size': '13px',
                    'text-transform': 'uppercase',
                },
                style: {
                    'text-align': 'right',
                    'font-size': '14px',
                    width: '20%',
                    'padding-right': '5px',
                    'white-space': 'nowrap',
                },
                dataType: 'percentage',
                precision: 2,
            },
        ];

        let tableRowItems: IRowItems[] = [];

        data.forEach((dataRow) => {
            let dataItem = Object.assign({}, dataRow);
            let tableTdItems = [];
            leadsTableInfo.forEach((rowInfo) => {
                let rowInfCopy = Object.assign({}, rowInfo);
                let value = dataItem[rowInfCopy.fieldId];

                if (value != null && rowInfCopy.dataType === 'currency') {
                    value = this.reusableFunctions.formatMoney(value);
                } else if (value != null && rowInfCopy.dataType === 'number') {
                    value = Math.round(value).toLocaleString();
                } else if (value != null && rowInfCopy.dataType === 'percentage') {
                    value = value.toFixed(rowInfCopy.precision) + '%';
                }

                if (rowInfCopy.isHyperlinked) {
                    rowInfCopy.routerLink = cardInfo.baseUrl;
                    rowInfCopy.queryParams = {
                        titleSuffix: ': ' + dataItem[rowInfCopy.hyperlinkFieldId],
                    };

                    if (cardInfo.cardId === 'leadSources') {
                        rowInfCopy.urlSegment = 'leadSource_stat';
                        rowInfCopy.queryParams['leadFilter'] =
                            dataItem[rowInfCopy.hyperlinkFieldId];
                    } else {
                        rowInfCopy.urlSegment = 'buyerAgent_stat';
                        rowInfCopy.queryParams['partnerFilter'] =
                            dataItem[rowInfCopy.hyperlinkFieldId];
                    }

                    rowInfCopy.hasAccess = this._userAccessService.hasAccessToPage(
                        rowInfCopy.routerLink + rowInfCopy.urlSegment
                    );
                }

                rowInfCopy.value = value;
                tableTdItems.push(rowInfCopy);
            });

            tableRowItems.push({
                tdList: tableTdItems,
            });
        });

        cardInfo.dataTableData = tableRowItems;
        cardInfo.action = action;
        cardInfo.searchTerm = cardInfo.searchTerm;

        if (data.length === 0) {
            cardInfo.hasData = false;
        } else {
            cardInfo.hasData = true;
        }
        cardInfo.isDataReady = true;
        cardInfo = Object.assign({}, cardInfo);
    }

    handleResponse_smallCards(
        data: ILeadsSummary[],
        cardInf: ILeadsSmalCard,
        action: NoDataActionType
    ) {
        let lastPeriodData = data.find((item) => item.periodGroup === 'Compare Period');
        let thisPeriodData = data.find((item) => item.periodGroup === 'This Period');
        let hasData = data.length > 1 && lastPeriodData != null && thisPeriodData != null;

        if (hasData) {
            this.getSmallCardGenericData(
                cardInf,
                cardInf.cardGroup === 'summary'
                    ? thisPeriodData.number
                    : thisPeriodData.conversionPercent,
                cardInf.cardGroup === 'summary'
                    ? lastPeriodData.number
                    : lastPeriodData.conversionPercent
            );

            cardInf.card.bottomCardData = this.getSmallCardBottomData(
                cardInf.cardGroup,
                thisPeriodData.overCreditPercent,
                thisPeriodData.underCreditPercent,
                thisPeriodData.targetCreditScore,
                thisPeriodData.notScoredPercent,
                cardInf.urlSegment,
                cardInf.card.routerLink
            );
        }
        cardInf.card.queryParams = {
            CreditScoreType: 'All',
        };
        cardInf.card.isDataReady = true;
        cardInf.card.hasData = hasData;
        cardInf.card.action = action;
        cardInf.card.searchTerm = cardInf.card.searchTerm;
        cardInf.card = Object.assign({}, cardInf.card);
    }

    getSmallCardGenericData(
        cardInf: ILeadsSmalCard,
        mainValue: number,
        lastPeriodValue: number,
        unit?: string
    ) {
        if (mainValue != null && lastPeriodValue != null) {
            let comparisonValueInfo = this.reusableFunctions.calculateComparisonPercentage(
                mainValue,
                lastPeriodValue
            );

            let caretInfo = this.reusableFunctions.getCaret(
                comparisonValueInfo.percentage,
                false,
                null,
                comparisonValueInfo.isComparable
            );
            cardInf.card.faIcon = caretInfo.ng_caret_icon;
            cardInf.card.faIconColor = caretInfo.color;
            cardInf.card.comparisonValue = caretInfo.comparison;
            cardInf.card.svgData = caretInfo.svgData;
            cardInf.card.unit = unit ? unit : null;
            cardInf.card.mainValue =
                cardInf.cardGroup === 'summary'
                    ? mainValue.toLocaleString()
                    : mainValue.toFixed(2) + '%';
        }
    }

    getSmallCardBottomData(
        cardGroup: 'summary' | 'pullthrough',
        over: number,
        under: number,
        threshold: number,
        noCreditScore: number,
        urlSegment: string,
        drilldownBaseUrl: string
    ): IBottomCardData[] {
        let decimalPlaces = 2;
        let hasAccess = this._userAccessService.hasAccessToPage(drilldownBaseUrl + urlSegment);

        return [
            {
                value:
                    over != null
                        ? cardGroup === 'summary'
                            ? over.toLocaleString()
                            : over.toFixed(decimalPlaces) + '%'
                        : '',
                description:
                    over != null ? 'At or Above ' + threshold.toFixed(0) + ' Credit Score' : '',
                hasAccess: hasAccess,
                isHyperlinked: true,
                routerLink: drilldownBaseUrl,
                urlSegment: urlSegment,
                queryParams: {
                    CreditScoreType: 'Above',
                    titleSuffix:
                        over != null
                            ? ': At or Above ' + threshold.toFixed(0) + ' Credit Score'
                            : '',
                },
            },
            {
                value:
                    under != null
                        ? cardGroup === 'summary'
                            ? under.toLocaleString()
                            : under.toFixed(decimalPlaces) + '%'
                        : '',
                description: under != null ? 'Below ' + threshold.toFixed(0) + ' Credit Score' : '',
                hasAccess: hasAccess,
                isHyperlinked: true,
                routerLink: drilldownBaseUrl,
                urlSegment: urlSegment,
                queryParams: {
                    CreditScoreType: 'Below',
                    titleSuffix:
                        under != null ? ': Below ' + threshold.toFixed(0) + ' Credit Score' : '',
                },
            },
            {
                value:
                    noCreditScore != null
                        ? cardGroup === 'summary'
                            ? noCreditScore.toLocaleString()
                            : noCreditScore.toFixed(decimalPlaces) + '%'
                        : '',
                description: noCreditScore != null ? 'No Credit Score' : '',
                hasAccess: hasAccess,
                isHyperlinked: true,
                routerLink: drilldownBaseUrl,
                urlSegment: urlSegment,
                queryParams: {
                    CreditScoreType: 'Not Scored',
                    titleSuffix: noCreditScore != null ? ': No Credit Score' : '',
                },
            },
        ];
    }
}
